import store from '../index'
import generateID from '@/utils'
import eventBus from '@/utils/eventBus'
import decomposeComponent from '@/utils/decomposeComponent'
import { $ } from '@/utils/utils'
import { commonStyle, commonAttr } from '@/views/manage/custom-screen/components/VisualDrag/custom-component/component-list'
import { createGroupStyle } from '@/utils/style'
import Vue from 'vue'
import { swap } from '@/utils/utils'
import toast from '@/utils/toast'
import { deepCopy } from '@/utils/utils'

export default {
  state: {
    areaData: { // 选中区域包含的组件以及区域位移信息
      style: {
        top: 0,
        left: 0,
        width: 0,
        height: 0
      },
      components: []
    },
    editor: null,
    editMode: 'edit', // 编辑器模式 edit preview
    canvasStyleData: { // 页面全局数据
      screenName: '项目大屏',
      width: 1920,
      height: 1080,
      scale: 100,
      color: '#000',
      opacity: 1,
      background: '#fff',
      // background: '#050b37',
      fontSize: 14
    },
    isInEdiotr: false, // 是否在编辑器中，用于判断复制、粘贴组件时是否生效，如果在编辑器外，则无视这些操作
    componentData: [], // 画布组件数据
    curComponent: null,
    curComponentIndex: null,
    // 点击画布时是否点中组件，主要用于取消选中组件用。
    // 如果没点中组件，并且在画布空白处弹起鼠标，则取消当前组件的选中状态
    isClickComponent: false,
    copyData: null, // 复制粘贴剪切
    isCut: false,
    menuTop: 0, // 右击菜单数据
    menuLeft: 0,
    menuShow: false,
    filterComponentList: []
  },
  mutations: {
    getEditor(state) {
      state.editor = $('#editor')
    },

    setAreaData(state, data) {
      state.areaData = data
    },

    compose({ componentData, areaData, editor }) {
      const components = []
      areaData.components.forEach(component => {
        if (component.component !== 'Group') {
          components.push(component)
        } else {
          // 如果要组合的组件中，已经存在组合数据，则需要提前拆分
          const parentStyle = { ...component.style }
          const subComponents = component.propValue
          const editorRect = editor.getBoundingClientRect()

          subComponents.forEach(component => {
            decomposeComponent(component, editorRect, parentStyle)
          })

          components.push(...component.propValue)
        }
      })

      const groupComponent = {
        id: generateID(),
        component: 'Group',
        label: '组合',
        icon: 'zuhe',
        ...commonAttr,
        style: {
          ...commonStyle,
          ...areaData.style
        },
        propValue: components
      }

      createGroupStyle(groupComponent)

      store.commit('compose/addComponent', {
        component: groupComponent
      })

      eventBus.$emit('hideArea')

      store.commit('batchDeleteComponent', areaData.components)
      store.commit('setCurComponent', {
        component: componentData[componentData.length - 1],
        index: componentData.length - 1
      })

      areaData.components = []
    },

    // 将已经放到 Group 组件数据删除，也就是在 componentData 中删除，因为它们已经从 componentData 挪到 Group 组件中了
    batchDeleteComponent({ componentData }, deleteData) {
      deleteData.forEach(component => {
        for (let i = 0, len = componentData.length; i < len; i++) {
          if (component.id === componentData[i].id) {
            componentData.splice(i, 1)
            break
          }
        }
      })
    },

    decompose({ curComponent, editor }) {
      const parentStyle = { ...curComponent.style }
      const components = curComponent.propValue
      const editorRect = editor.getBoundingClientRect()

      store.commit('deleteComponent')
      components.forEach(component => {
        decomposeComponent(component, editorRect, parentStyle)
        store.commit('addComponent', { component })
      })
    },
    aceSetCanvasData(state, value) {
      state.canvasStyleData = value
    },

    aceSetcurComponent(state, value) {
      for (let i = 0; i < state.componentData.length; i++) {
        if (state.componentData[i].id === value.id) {
          state.componentData.splice(i, 1)
        }
      }
      state.componentData.push(value)
      state.curComponent = value
    },

    setClickComponentStatus(state, status) {
      state.isClickComponent = status
    },

    setEditMode(state, mode) {
      state.editMode = mode
    },

    setInEditorStatus(state, status) {
      state.isInEdiotr = status
    },

    setCanvasStyle(state, style) {
      state.canvasStyleData = style
    },

    setCurComponent(state, { component, index }) {
      state.curComponent = component
      state.curComponentIndex = index
    },

    setShapeStyle({ curComponent }, { top, left, width, height, rotate }) {
      if (top) curComponent.style.top = Math.round(top)
      if (left) curComponent.style.left = Math.round(left)
      if (width) curComponent.style.width = Math.round(width)
      if (height) curComponent.style.height = Math.round(height)
      if (curComponent.component === 'ProjectName') {
        if (height) curComponent.style.lineHeight = Math.round(height)
      }
      if (rotate) curComponent.style.rotate = Math.round(rotate)
    },

    setShapeSingleStyle({ curComponent }, { key, value }) {
      curComponent.style[key] = value
    },

    setComponentData(state, componentData = []) {
      Vue.set(state, 'componentData', componentData)
    },

    addComponent(state, { component, index }) {
      if (index !== undefined) {
        state.componentData.splice(index, 0, component)
      } else {
        if (component.component === 'VMap') {
          state.componentData.unshift(component)
        } else {
          state.componentData.push(component)
        }
      }
    },

    deleteComponent(state, index) {
      if (index === undefined) {
        index = state.curComponentIndex
      }

      if (index === state.curComponentIndex) {
        state.curComponentIndex = null
        state.curComponent = null
      }

      if (/\d/.test(index)) {
        state.componentData.splice(index, 1)
      }
    },
    upComponent(state, rootState) {
      const { componentData, curComponentIndex } = state
      // 上移图层 index，表示元素在数组中越往后
      if (curComponentIndex < componentData.length - 1) {
        swap(componentData, curComponentIndex, curComponentIndex + 1)
        state.curComponentIndex = curComponentIndex + 1
      } else {
        toast('已经到顶了')
      }
    },

    downComponent(state) {
      const { componentData, curComponentIndex } = state
      // 下移图层 index，表示元素在数组中越往前
      if (curComponentIndex > 0) {
        swap(componentData, curComponentIndex, curComponentIndex - 1)
        state.curComponentIndex = curComponentIndex - 1
      } else {
        toast('已经到底了')
      }
    },

    topComponent(state) {
      const { componentData, curComponentIndex, curComponent } = state
      // 置顶
      if (curComponentIndex < componentData.length - 1) {
        componentData.splice(curComponentIndex, 1)
        componentData.push(curComponent)
        state.curComponentIndex = componentData.length - 1
      } else {
        toast('已经到顶了')
      }
    },

    bottomComponent(state) {
      const { componentData, curComponentIndex, curComponent } = state
      // 置底
      if (curComponentIndex > 0) {
        componentData.splice(curComponentIndex, 1)
        componentData.unshift(curComponent)
        state.curComponentIndex = 0
      } else {
        toast('已经到底了')
      }
    },
    copy(state) {
      if (!state.curComponent) {
        toast('请选择组件')
        return
      }

      // 如果有剪切的数据，需要先还原
      restorePreCutData(state)
      copyData(state)

      state.isCut = false
    },

    paste(state, isMouse) {
      if (!state.copyData) {
        toast('请选择组件')
        return
      }

      const data = state.copyData.data

      if (isMouse) {
        data.style.top = state.menuTop
        data.style.left = state.menuLeft
      } else {
        data.style.top += 10
        data.style.left += 10
      }
      console.log(data)
      store.commit('addComponent', { component: deepCopyHelper(data) })
      if (state.isCut) {
        state.copyData = null
      }
    },

    cut(state) {
      if (!state.curComponent) {
        toast('请选择组件')
        return
      }

      // 如果重复剪切，需要恢复上一次剪切的数据
      restorePreCutData(state)
      copyData(state)

      store.commit('deleteComponent')
      state.isCut = true
    },
    showContextMenu(state, { top, left }) {
      state.menuShow = true
      state.menuTop = top
      state.menuLeft = left
    },

    hideContextMenu(state) {
      state.menuShow = false
    },
    setFilterComponentList(state, filterComponentList) {
      state.filterComponentList = filterComponentList
    }
  }
}

// 恢复上一次剪切的数据
function restorePreCutData(state) {
  if (state.isCut && state.copyData) {
    const data = deepCopy(state.copyData.data)
    const index = state.copyData.index
    store.commit('addComponent', { component: data, index })
    if (state.curComponentIndex >= index) {
      // 如果当前组件索引大于等于插入索引，需要加一，因为当前组件往后移了一位
      state.curComponentIndex++
    }
  }
}

function copyData(state) {
  state.copyData = {
    data: deepCopy(state.curComponent),
    index: state.curComponentIndex
  }
}

function deepCopyHelper(data) {
  const result = deepCopy(data)
  result.id = generateID()
  if (result.component === 'Group') {
    result.propValue.forEach((component, i) => {
      result.propValue[i] = deepCopyHelper(component)
    })
  }

  return result
}
